import styled from 'styled-components';
import { fontSize } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';

export const Label = styled.h3`
  font-size: ${fontSize['$font-size-sm']};
  line-height: ${fontSize['$line-height-sm']};
  font-weight: normal;
  color: ${colors['$hpx-grey-600']};
`;

export const Value = styled.p`
  font-size: ${fontSize['$font-size-md']};
  line-height: ${fontSize['$line-height-md']};
  padding: 2px 0;
  margin-bottom: 8px;
`;
